import React from "react";
import "./styles.css";
import SearchableDropdown from "./dropdown-component";
import Text from "../typography/text";
import { colors } from "../../theme/colors";
import DeleteIcon from "../../icons/delete-icon";
import ReactSelectPaginate from "./react-select-async";
import Select, { components } from 'react-select';

const AutofillSafeInput = (props) => (
  <components.Input {...props} autoComplete="new-password" />
);

const MultiSelectInput = ({
  value,
  setValue,
  placeholder,
  options,
  labelKey,
  labelValue,
  type
}) => {
  const handleRemove = (val) => {
    const newValue = value.filter((item) => item !== val);
    setValue(newValue);
  };

  return (
    <div style={{ width: "100%" }}>
      {/* <SearchableDropdown
        label=""
        placeholder={placeholder}
        options={options}
        value={value}
        setValue={setValue}
        labelKey={labelKey}
        labelValue={labelValue}
      />
      <div className="searchable-dropdown-selected-parent">
        {value?.map((val) => {
          return (
            <div className="searchable-dropdown-selected-container">
              <Text variant="smallText" color="primaryColor">
                {val}
              </Text>
              <div
                style={{ cursor: "pointer" }}
                onClick={() => handleRemove(val)}
              >
                <DeleteIcon className="primary-icon-container" />
              </div>
            </div>
          );
        })}
      </div> */}
      {type !== "NonAsync" && (
        <ReactSelectPaginate placeholder={placeholder} />
      )}
      {type === "NonAsync" &&
        <Select
          isMulti
          options={options}
          value={value}
          onChange={(selected) => setValue(selected)}
          placeholder={placeholder}
          components={{ Input: AutofillSafeInput }}
          styles={{
            // menuPortal: (base) => ({ ...base, zIndex: menuZIndex }),
            placeholder: (base) => ({
              ...base,
              fontFamily: "Figtree, sans-serif",
              fontSize: "14px",
              color: colors["lightText"],
            }),
            input: (base) => ({
              ...base,
              fontFamily: "Figtree, sans-serif",
            }),
            option: (base, state) => ({
              ...base,
              fontFamily: "Figtree, sans-serif",
              fontSize: "14px",
              color: state.isFocused ? colors["white"] : colors["darkText"],
              backgroundColor: state.isFocused
                ? colors["primaryColor"]
                : colors["white"],
              borderRadius: "4px",
              paddingTop: "8px",
              paddingBottom: "8px",
              cursor: "pointer",
            }),
          }}
        />
      }
    </div>
  );
};

export default MultiSelectInput;
